import axios from "axios";
import { API_URL } from "../constants";

export interface AssistantSettings {
  company?: string;
  /** Masked by the backend (last 4 chars only) — never the full key. */
  apiKey: string | null;
  model: string | null;
  isActive: boolean;
}

export async function fetchAssistantSettings(
  companyId: string
): Promise<AssistantSettings> {
  const res = await axios.get(`${API_URL}/${companyId}/assistant-settings`);
  return res.data.settings as AssistantSettings;
}

/**
 * Omit `apiKey` to keep the stored one. The backend also ignores the masked
 * placeholder, so submitting the displayed value is safe.
 */
export async function saveAssistantSettings(
  companyId: string,
  patch: { apiKey?: string; model?: string; isActive?: boolean }
): Promise<AssistantSettings> {
  const res = await axios.patch(
    `${API_URL}/${companyId}/assistant-settings`,
    patch
  );
  return res.data.settings as AssistantSettings;
}
